var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerNotSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.94 10.85V10.92C23.35 4.32 17.51 -0.550005 10.91 0.0499952C8.93 0.229995 7.02 0.899995 5.37 2C2.36 4.01 0.420002 7.25 0.0600015 10.85C-0.289998 14.42 0.990001 17.96 3.53 20.49L11.01 27.99C11.56 28.54 12.45 28.55 13 27.99L20.45 20.49C23 17.96 24.27 14.42 23.92 10.85H23.94ZM18.49 18.5L12 24.99L5.51 18.5C3.57 16.56 2.61 13.86 2.87 11.13C3.14 8.36 4.64 5.86 6.95 4.31C10.01 2.28 14 2.28 17.06 4.31C19.37 5.85 20.86 8.34 21.14 11.1C21.41 13.84 20.45 16.55 18.5 18.5H18.49Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.49 18.5L12 24.99L5.51 18.5C3.57 16.56 2.61 13.86 2.87 11.13C3.14 8.36001 4.64 5.86001 6.95 4.31001C10.01 2.28001 14 2.28001 17.06 4.31001C19.37 5.85001 20.86 8.34001 21.14 11.1C21.41 13.84 20.45 16.55 18.5 18.5H18.49Z",
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerNotSelected);
export default __webpack_public_path__ + "static/media/markerNotSelected.37f2dcada3e7583896793d3fc1b30352.svg";
export { ForwardRef as ReactComponent };